import { createSlice } from "@reduxjs/toolkit";
import HbsHastaMuayeneDTO from "src/models/HastaServis/VwHbsHastaMuayeneDTO";
import HbsHastaMuayeneSablonDTO from "src/models/HastaServis/HbsHastaMuayeneSablonDTO";
import VwHbsHastarecete1DTO from "src/models/HastaServis/VwHbsHastarecete1DTO ";
import VwHbsHastarecete2DTO from "src/models/HastaServis/VwHbsHastarecete2DTO";
import VwHbsServispersonelDTO from "src/models/Settings/Generals/VwHbsServispersonelDTO";
import VwHbsServisveriDTO from "src/models/Settings/Generals/VwHbsServisveriDTO";
import VwRoldbServistanimDTO from "src/models/Settings/Generals/VwRoldbServistanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { HastaMuayeneApi } from "src/services/HastaServis/HastaMuayeneApi";
import { HastaServisApi } from "src/services/HastaServis/HastaServisApi";
import { bransTanimApi } from "src/services/Settings/Generals/BransTanimApi";
import { helper } from "src/utils/helper";
import VwHastaservisListeDTO from "src/models/HastaServis/VwHastaservisListeDTO";

export class HastaServisSearch {
  servisTip: string = "1";
  servisId: Array<number> = [];
  islemDurum: string = "3";
  baslangicTarih: string = helper.datetimeToday();
  bitisTarih: string = helper.datetimeToday();
  doktorId: Array<number> = [];
  searchText: string = "";
  yetkiliServisler: Array<number> = [];
}
export interface IHastaServisState {
  rolServisler: Array<VwRoldbServistanimDTO>,
  searchModel: HastaServisSearch,
  servisPersonel: Array<VwHbsServispersonelDTO>,
  activeRow: VwHastaservisListeDTO,
  tabValue: string,
  selectServisveri: VwHbsServisveriDTO,
  teleDiagnosisOpen: boolean,
  sablonSecimOpen: boolean,
  sablonActiveRow: HbsHastaMuayeneSablonDTO,
  hastaMuayene: HbsHastaMuayeneDTO,
  hastaRecete1: VwHbsHastarecete1DTO,
  hastaRecete2: VwHbsHastarecete2DTO,
  refetchRecete2: boolean,
  receteFormOpen: boolean,
  labEditMode: boolean,
  secilenhasta:VwHastaservisListeDTO
}
const HastaServisSlice = createSlice<IHastaServisState, MapReducerPayloads<IHastaServisState, {
  setState: IHastaServisState,
  setSearchModel: HastaServisSearch
  setTabValue: string,
  setSelectServisveri: VwHbsServisveriDTO,
  setTeleDiagnosisOpen: boolean,
  setHastaMuayene: HbsHastaMuayeneDTO,
  setSablonActiveRow: HbsHastaMuayeneSablonDTO,
  setHbsHastaRecete1: VwHbsHastarecete1DTO,
  setHbsHastaRecete2: VwHbsHastarecete2DTO
  setRefetchRecete2: boolean,
  SetReceteFormOpen: boolean,
  setLabEditMode: boolean,
  setSecilenHasta:VwHastaservisListeDTO,

}>>({
  name: 'hastaServis',
  initialState: {
    rolServisler: [],
    searchModel: new HastaServisSearch(),
    servisPersonel: [],
    activeRow: JSON.parse(sessionStorage.getItem("hastaServis")) || new VwHastaservisListeDTO(),
    tabValue: "1",
    selectServisveri: new VwHbsServisveriDTO(),
    teleDiagnosisOpen: false,
    sablonSecimOpen: false,
    sablonActiveRow: new HbsHastaMuayeneSablonDTO(),
    hastaMuayene: new HbsHastaMuayeneDTO(),
    hastaRecete1: new VwHbsHastarecete1DTO(),
    hastaRecete2: new VwHbsHastarecete2DTO(),
    refetchRecete2: false,
    receteFormOpen: false,
    labEditMode: false,
    secilenhasta: new VwHastaservisListeDTO(),

  },
  reducers: {
    setState: (state, action) => action.payload,
    setSearchModel: (state, action) => {
      state.searchModel = action.payload
      // state.searchModel.islemDurum = action.payload?.servisTip === "5" ? "1" : "3"
    },
    setTabValue: (state, action) => {
      state.tabValue = action.payload
    },
    setSelectServisveri: (state, action) => {
      state.selectServisveri = action.payload
    },
    setTeleDiagnosisOpen: (state, action) => {
      state.teleDiagnosisOpen = action.payload
    },
    setHastaMuayene: (state, action) => {
      state.hastaMuayene = action.payload
    },
    setSablonActiveRow: (state, action) => {
      state.sablonActiveRow = action.payload
    },
    setHbsHastaRecete1: (state, action) => {
      state.hastaRecete1 = action.payload
    },
    setHbsHastaRecete2: (state, action) => {
      state.hastaRecete2 = action.payload
    },
    setRefetchRecete2: (state, action) => {
      state.refetchRecete2 = action.payload
    },
    SetReceteFormOpen: (state, action) => {
      state.receteFormOpen = action.payload
    },
    setLabEditMode: (state, action) => {
      state.labEditMode = action.payload
    },
    setSecilenHasta: (state, action) => {
      state.secilenhasta = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(HastaServisApi.endpoints.findVwHbsServispersonel.matchFulfilled, (state, action) => {
      state.servisPersonel = action.payload
    })
    builder.addMatcher(HastaServisApi.endpoints.getVwHbsHastaservis.matchFulfilled, (state, action) => {
      sessionStorage.setItem("hastaServis", JSON.stringify(action.payload))
      state.activeRow = action.payload
    })
    builder.addMatcher(bransTanimApi.endpoints.getHbsServisveri.matchFulfilled, (state, action) => {
      if (action.payload.length > 0)
        state.selectServisveri = action.payload[0]

    })
    builder.addMatcher(HastaMuayeneApi.endpoints.getVwHbsHbsHastaRecete1BydId.matchFulfilled, (state, action) => {
      state.hastaRecete1 = action.payload
    })
  }
})
export default HastaServisSlice;